import React from "react";

const Footer = (props) => {

    return (
        <div>
            Stopka
        </div>
    );
};

export default Footer;